import { Button, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

const ReportFrequencySelector = ({ value, title, options = [], onChange }) => {
  return (
    <Stack direction="row" alignItems="center" spacing={5}>
      <Typography variant="subtitle2" color="text.secondary" sx={{ whiteSpace: 'nowrap', fontSize: "0.75rem", fontWeight: 600}}>
        {title}
      </Typography>
      <Stack direction="row" spacing={5}>
        {options.map((option) => {
          const isSelected = value === option.value; 
          return (
            <Button
              key={option.value || option.id || option.label}
              variant="outlined"
              onClick={() => onChange(option.value)}
              endIcon={isSelected ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}

              sx={{
                px: 2,
                py: 0.75,
                fontSize: "0.7rem",
                minWidth: 120,
                justifyContent: 'space-between',
                borderColor: isSelected ? 'primary.main' : 'divider', // Highlight border if selected
                backgroundColor: 'transparent', // Always have a transparent background
                color: isSelected ? 'primary.main' : 'text.primary', // Change text/icon color if selected
                '&:hover': {
                  borderColor: 'primary.main',
                  backgroundColor: 'action.hover', // Use a subtle grey for hover on all buttons
                },
              }}
            >
              {option.label}
            </Button>
          );
        })}
      </Stack>
    </Stack>
  );
};

export default memo(ReportFrequencySelector);
